import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

// TODO: move all models to shared directory

export type AppointmentAddingEvent = {
  component: React.ComponentType<unknown>;
  fromComponent: React.ComponentType<unknown>;
  fromData: ScheduleBoardJobModel;
  itemData: ScheduleBoardJobModel;
  itemElement: HTMLElement;
  toComponent: React.ComponentType<unknown>;
  toData?: ScheduleBoardJobModel;
};

export type AppointmentRemovingEvent = {
  component: React.ComponentType<unknown>;
  fromComponent: React.ComponentType<unknown>;
  fromData: ScheduleBoardJobModel;
  itemData: ScheduleBoardJobModel;
  itemElement: HTMLElement;
  toComponent: React.ComponentType<unknown>;
};

export type AppointmentDraggingStartEvent = {
  cancel: boolean;
  component: React.ComponentType<unknown>;
  fromData: ScheduleBoardJobModel;
  itemData: ScheduleBoardJobModel;
  itemElement: HTMLElement;
};

export enum ContextMenuItemType {
  EMPTY = 'empty',
}

export type ContextMenuItemData = {
  laneId?: string;
};

export type ContextMenuItem = {
  type?: ContextMenuItemType;
  text: string;
  onItemClick: (data?: ContextMenuItemData) => void;
  disabled?: boolean;
  cancel?: boolean;
};

export type ContextMenuItemClickEvent = {
  component: React.ComponentType<unknown>;
  itemData: ContextMenuItem;
};

export type EventHandler =
  | ((e: AppointmentAddingEvent) => void)
  | ((e: AppointmentRemovingEvent) => void)
  | ((e: any) => void)
  | ((e: any) => void)
  | ((e: any) => void)
  | ((e: any) => void)
  | ((e: AppointmentDraggingStartEvent) => void);

export enum BoardViewType {
  DEFAULT = 'default',
  LIST = 'list',
}

export enum VehicleDetails {
  MAKE = 'make',
  MODEL = 'model',
  COLOR = 'color',
  PLATE = 'plate',
}

export type FactorOfSixty = 1 | 2 | 3 | 4 | 5 | 6 | 10 | 12 | 15 | 20 | 30 | 60;

export type JobDetailsModalActiveKey = '1' | '2' | '3' | '4' | '5';
